import React, {useRef, useState, useCallback, useEffect} from 'react';
import * as SizeFunctions from './SizeFunctions';

function App(props) {

  const [mainContainerHeight, setMainContainerHeight] = useState(0);
  const setMainContainerWidth = useState(0)[1];
  const element = useRef(null);
  const handler = useCallback(SizeFunctions.createSizeHandler(element, setMainContainerHeight, setMainContainerWidth, props),[setMainContainerHeight, setMainContainerWidth, props]);  
  SizeFunctions.useEventListener('resize', handler);
  useEffect(() =>{SizeFunctions.createSizeEffect(element, mainContainerHeight, setMainContainerHeight, setMainContainerWidth, props);}, [mainContainerHeight, setMainContainerHeight, setMainContainerWidth, props])

  var width = props.width;


  return <div width={width} ref={element}>
          {props.contents}
          {props.subtitle}
        </div>
}


export default App;
